import { UserResource } from '@/models'
import { SettingResource } from '@/models/Setting'
import {
    APP_LOGOUT,
    CURRENT_USER_EDIT_FAILURE,
    CURRENT_USER_EDIT_REQUEST,
    CURRENT_USER_EDIT_SUCCESS,
    CURRENT_USER_FAILURE,
    CURRENT_USER_REQUEST,
    CURRENT_USER_SUCCESS,
} from '@/redux/actionTypes'

export interface UserPermission {
    id: string
    name: string
}

export interface UserState {
    currentUser?: UserResource
    error?: unknown
    loading: boolean
    settings: SettingResource[]
    permissions: UserPermission[]
}

export type UserAction =
    | { type: typeof CURRENT_USER_REQUEST }
    | { type: typeof CURRENT_USER_SUCCESS, user: UserResource, permissions: UserPermission[], settings: SettingResource[] }
    | { type: typeof CURRENT_USER_FAILURE, error: unknown }
    | { type: typeof CURRENT_USER_EDIT_REQUEST }
    | { type: typeof CURRENT_USER_EDIT_SUCCESS, user: UserResource }
    | { type: typeof CURRENT_USER_EDIT_FAILURE, error?: unknown }
    | { type: typeof APP_LOGOUT }

const initialState: UserState = {
    currentUser: undefined,
    error: undefined,
    loading: false,
    settings: [],
    permissions: [],
}

export const userReducer = (state: UserState = initialState, action: UserAction): UserState => {
    switch (action.type) {
        case CURRENT_USER_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case CURRENT_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                currentUser: action.user,
                permissions: action.permissions,
                settings: action.settings,
            }
        case CURRENT_USER_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error,
                currentUser: undefined,
                settings: [],
            }
        case CURRENT_USER_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case CURRENT_USER_EDIT_SUCCESS:
            return {
                ...state,
                currentUser: action.user,
                loading: false,
            }
        case CURRENT_USER_EDIT_FAILURE:
            return {
                ...state,
                loading: false,
            }
        case APP_LOGOUT:
            return { ...initialState }
        default:
            return state
    }
}
